import { ReactNode } from 'react';
import { extendClassName } from 'utils/common';
import CardWithBackgroundImage from '../CardWithBackgroundImage';
import PaddedMaxWidthContainer from '../layout/PaddedMaxWidthContainer';

interface GraphicWrapper {
  id?: string;
  imageDirectory?: string;
  imageFname?: string;
  imageOverlayOpacity?: number;
  imagePosition?: string;
  imageOverlay?: boolean;
  children?: ReactNode;
  additionalClassName?: string;
  style?: React.CSSProperties;
}

const GraphicWrapper = ({
  id,
  imageDirectory = 'token-town',
  imageFname = 'cityscape-bottom',
  imageOverlayOpacity = 18,
  imagePosition = 'center',
  imageOverlay = false,
  children,
  additionalClassName,
  style,
}: GraphicWrapper) => {
  return (
    <div
      id={id}
      className={extendClassName(
        'graphicWrapper fullWidth flexCentered',
        additionalClassName
      )}
      style={style}
    >
      <CardWithBackgroundImage
        imageDirectory={imageDirectory}
        imageFname={imageFname}
        objectPosition={imagePosition}
        showOverlay={imageOverlay}
        overlayOpacity={imageOverlayOpacity}
      >
        <PaddedMaxWidthContainer>{children}</PaddedMaxWidthContainer>
      </CardWithBackgroundImage>

      <style jsx>
        {`
          :global(.graphicWrapper > .cardWithBackgroundImage) {
            padding: 4em 0;
          }

          :global(.graphicWrapper .cardWithBackgroundImage h1),
          :global(.graphicWrapper .cardWithBackgroundImage h2) {
            color: white;
            text-shadow:
              -1px -1px #9b9b9b,
              1px 1px #90f6df,
              1px 1px 15px #90f6df;
            font-size: 1em;
            letter-spacing: 0.1em;
            line-height: 2;
          }

          :global(.graphicWrapper .cardWithBackgroundImage h1 strong) {
            text-shadow:
              -2px -2px #9b9b9b,
              2px 2px #90f6df,
              1px 1px 15px #90f6df;
            font-size: 2.25em;
          }

          :global(.graphicWrapper .cardWithBackgroundImage h2 strong) {
            font-size: 1.4em;
          }

          :global(.graphicWrapper .cardWithBackgroundImage h2) {
            font-size: 1.2em;
          }

          :global(.graphicWrapper .children .paddedMaxWidthContainer > p > a),
          :global(.graphicWrapper .children .paddedMaxWidthContainer > p) {
            color: white;
            text-shadow: 0 0 7px #000000;
          }

          @media (min-width: 700px) {
            :global(.graphicWrapper .cardWithBackgroundImage h1),
            :global(.graphicWrapper .cardWithBackgroundImage h2) {
              font-size: 2em;
            }
          }
        `}
      </style>
    </div>
  );
};

export default GraphicWrapper;
